import CarouselComponent from "../lib/carousel_component";
import {CarouselDot} from "./carousel_dot";

export const CarouselPaginationConfig = {
    componentTypeKey: 'CarouselPagination',
    baseHtmlClass: 'carousel__pagination',
    selector: '.carousel__pagination',
    dotSelector: '.carousel__dot',
};

export class CarouselPagination extends CarouselComponent {
    
    static createElement() {
        const element = document.createElement('div');
        element.className = CarouselPaginationConfig.baseHtmlClass;
        return element;
    }

    static get config() {
        return CarouselPaginationConfig;
    }

    constructor(id_or_element, carousel) {
        super(id_or_element, carousel, CarouselPaginationConfig);
        
        this.carousel = carousel;
        this.dots = [];

        this.initializeDots();
        this.render();
    }

    initializeDots() {
        // Clear existing dots
        this.dots = [];
        
        // Get existing dot elements from DOM
        const existingDots = Array.from(this.element.querySelectorAll(CarouselPaginationConfig.dotSelector));
        
        // Create dots to match slide count
        const totalSlides = this.carousel.slides.length;
        
        for (let i = 0; i < totalSlides; i++) {
            let dotElement;
            
            if (existingDots[i]) {
                // Use existing dot element
                dotElement = existingDots[i];
            } else {
                // Create new dot element
                dotElement = CarouselDot.createElement();
                this.element.appendChild(dotElement);
            }
            
            const dot = new CarouselDot(dotElement, this.carousel, i);
            this.dots.push(dot);
        }
        
        // Remove any extra existing dots
        for (let i = totalSlides; i < existingDots.length; i++) {
            existingDots[i].remove();
        }
        
        // Update visibility based on slide count
        this.render();
    }

    updateActiveDot(activeIndex) {
        this.dots.forEach((dot, index) => {
            dot.setActive(index === activeIndex);
        });
    }

    render() {
        // Hide pagination if there's only one slide
        const totalSlides = this.carousel.slides.length;
        this.element.style.display = totalSlides <= 1 ? 'none' : '';
    }
}